module.exports = __webpack_public_path__ + "img/Jamaica.a07aec7d.png";